export class LoginModel {
    public cardnumber : string;
    public bearerid : string;
    public pin : string;
}

export class AadhaarLoginModel {
    public cardnumber : string;
    public aadhaar: string;
    public captchaid: string;
    public captcha : string;
    public uuid: string;
    public userid: string;
    public otp: string;
}